import React from 'react'

import config from '../config.js'

import axios from 'axios'

import { MuiThemeProvider } from '@material-ui/core/styles'

import { Button, TextField } from '@material-ui/core/'

import InviteEmail from './InviteEmail'
import InvitePhone from './InvitePhone'
import InviteInternal from './InviteInternal'
import LoadingIcon from './LoadingIcon'

class Contact extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isUser: false,
      users: {}
    }
  }

  componentDidMount() {
    let phoneNumbersOnly = this.props.contact.phone_numbers.map(
      item => item.number
    )
    let emailAddressesOnly = this.props.contact.email_addresses.map(
      item => item.address
    )

    let apiURL = ''
    let makeCall = false
    let foundUser = false

    if (this.props.sessionId !== undefined) {
      //apiURL = '//mark.cookn-cloud.appspot.com' + '/api/v3/web/accounts?sid=' + this.props.sessionId
      apiURL =
        config.apiServer + '/api/v3/web/accounts?sid=' + this.props.sessionId
      makeCall = true
    }

    if (phoneNumbersOnly.length > 0 && emailAddressesOnly.length > 0) {
      apiURL =
        apiURL +
        '&eml=' +
        encodeURIComponent(emailAddressesOnly.join(',')) +
        '&phn=' +
        encodeURIComponent(phoneNumbersOnly.join(','))
    } else if (phoneNumbersOnly.length > 0) {
      apiURL = apiURL + '&phn=' + encodeURIComponent(phoneNumbersOnly.join(','))
    } else if (emailAddressesOnly.length > 0) {
      apiURL =
        apiURL + '&eml=' + encodeURIComponent(emailAddressesOnly.join(','))
    } else {
      makeCall = false
    }

    // Before displaying the buttons, check to see if this contact is already a Cook'n friend
    // This means checking each email and phone number to see if they're associated with a Cook'n account
    // If you find a Cook'n account, display a single invite button that sends an internal invite
    // If there isn't a Cook'n account, display an external invite button for each email and phone number
    // So the user can choose which method to use to invite their contact to be a friend

    // API call
    if (makeCall) {
      axios.get(apiURL, {}).then(
        response => {
          const usersJson = response.data.result.accounts

          if (Object.keys(usersJson).length > 0) {
            this.setState((state, props) => ({
              isUser: true,
              users: usersJson
            }))
          }
        },
        error => {
          console.log(error)
        }
      )
    }
  }

  render() {
    const { isUser, users } = this.state

    let firstName = ''
    let lastName = ''

    let phoneNumbers = this.props.contact.phone_numbers
    let emailAddresses = this.props.contact.email_addresses

    let cooknUserInviteList = ''
    let phoneNumberInviteList = ''
    let emailInviteList = ''

    if (this.props.contact.first_name !== '') {
      firstName = this.props.contact.first_name
    }
    if (this.props.contact.last_name !== '') {
      lastName = this.props.contact.last_name
    }

    if (isUser === true) {
      // If there were results, that means that at least one of these contact methods is associated
      // With a Cook'n user who is not yet a friend.
      // Build an internal invite button for each unique user in the results
      let usersUnique = []

      for (let [key, value] of Object.entries(users)) {
        if (usersUnique.indexOf(value.accountId) === -1) {
          usersUnique.push(value.accountId)
        }
      }

      const internalInvites = usersUnique.map(item => (
        <InviteInternal
          key={item}
          aid={this.props.aid}
          firstName={firstName}
          lastName={lastName}
          fid={item}
          sendInternalInvite={this.props.sendInternalInvite}
        />
      ))

      cooknUserInviteList = (
        <span className="userContacts">{internalInvites}</span>
      )
    } else {
      if (this.props.contact.phone_numbers.length >= 1) {
        const phoneNumberInvites = phoneNumbers.map(item => (
          <InvitePhone
            key={item.number}
            device={this.props.device}
            version={this.props.version}
            aid={this.props.aid}
            firstName={firstName}
            lastName={lastName}
            phoneNumber={item.number}
            sendPhoneInvite={this.props.sendPhoneInvite}
          />
        ))

        phoneNumberInviteList = (
          <span className="phoneContacts">{phoneNumberInvites}</span>
        )
      }
      if (this.props.contact.email_addresses.length >= 1) {
        const emailInvites = emailAddresses.map(item => (
          <InviteEmail
            key={item.address}
            aid={this.props.aid}
            firstName={firstName}
            lastName={lastName}
            emailAddress={item.address}
            sendExternalInvite={this.props.sendExternalInvite}
          />
        ))

        emailInviteList = <span className="emailContacts">{emailInvites}</span>
      }
    }

    if (
      cooknUserInviteList !== '' ||
      phoneNumberInviteList !== '' ||
      emailInviteList !== ''
    ) {
      return (
        <li className="contact-container">
          {cooknUserInviteList}
          {phoneNumberInviteList}
          {emailInviteList}
        </li>
      )
    } else {
      return ''
    }
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/Components/Contact.js